import { Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { RedirectType } from "src/types/apps";

import Context from "../context";
import { useGetRedirects } from "../service/useGetRedirects";

export default function RedirectsSelector() {
	const { state, actions } = useContext(Context);

	const { data } = useGetRedirects();

	const { translate } = useLocales();

	const onChange = (newValue: RedirectType) => {
		actions.setRedirect(newValue);
	};

	if (!state.redirectSelected) {
		return null;
	}

	return (
		<Autocomplete
			getOptionLabel={(option: RedirectType) => option.redirectURI}
			onChange={(_event, newValue) => onChange(newValue)}
			filterOptions={(options) => options}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			options={data}
			fullWidth
			disableClearable
			sx={{ maxWidth: 350 }}
			renderInput={(params) => <TextField {...params} label={translate("Selecciona una URL")} />}
			renderOption={(props, option) => (
				<li key={option.id} {...props}>
					<Typography variant='body2'>{option.redirectURI}</Typography>
				</li>
			)}
			value={state.redirectSelected}
		/>
	);
}
